<template>
    <div>
      <component v-if="sidebarComponent" :is="sidebarComponent" />
      <app-tools v-if="isToolBarVisible && !sidebarComponent" />
    </div>
  
</template>
<style scoped>
h6{
  font-size: 9px
}

</style>

<script>
  import AppTools from '@/components/AppTools'
  import { mapGetters } from 'vuex'
    
    export default {
        name: "AppNavigation",
        components:{
          AppTools
        },
        data: () => ({
            fav: true,
            menu: true,
            message: false,
            hints: true,
        }),
        computed:{
          
          ...mapGetters({
            isToolBarVisible: 'app/isToolBarVisible',
            sidebarComponent: 'ui/sidebarComponent'
          })
        },
        methods: {
          authenticate(){
            this.$store.dispatch('session/refresh')
          }
        }
    }
</script>
